// extracted by mini-css-extract-plugin
export default {"full-page-loader":"style_full-page-loader__413IP"};